import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import { IntlProvider } from "react-intl";

import "@formatjs/intl-pluralrules/polyfill";
import "@formatjs/intl-pluralrules/dist/locale-data/en";
import "@formatjs/intl-pluralrules/dist/locale-data/it";

import "@formatjs/intl-listformat/polyfill";
import "@formatjs/intl-listformat/dist/locale-data/en";
import "@formatjs/intl-listformat/dist/locale-data/it";

import languages from "./languages";

function getLocale(langKey, defaultLocale) {
  switch (langKey) {
    case "en":
    case "it":
      return langKey;
    default:
      return defaultLocale;
  }
}

export default function PageIntlProvider({ langKey, children }) {
  const { site } = useStaticQuery(graphql`
    {
      site {
        siteMetadata {
          defaultLanguageKey
        }
      }
    }
  `);

  const defaultLocale = site.siteMetadata.defaultLanguageKey;

  const locale = getLocale(langKey, defaultLocale);
  const messages = languages[locale]
    ? languages[locale].messages
    : languages[defaultLocale].messages;

  return (
    <IntlProvider
      locale={locale}
      defaultLocale={site.siteMetadata.defaultLanguageKey}
      messages={messages}
      children={children}
    />
  );
}
